import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr/translation.json";

const resources = {
  fr: { translation: fr },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false, // React already escapes
  },
  detection: {
    // i18next-browser-languageDetector would go here if added later;
    // for now we rely on the browser's navigator.language via custom logic.
  },
});

// Auto-detect browser language and switch if supported
if (typeof navigator !== "undefined") {
  const browserLang = navigator.language?.split("-")[0];
  if (browserLang && resources[browserLang as keyof typeof resources]) {
    void i18n.changeLanguage(browserLang);
  }
}

export default i18n;
